import { createContext, useContext } from "@wordpress/element";
import PropTypes from "prop-types";

export const ProductContext = createContext({});
export const useProductContext = () => useContext(ProductContext);

export const ProductContextProvider = ({ product, cartLineItem, children }) => {
	const contextValue = {
		product,
		cartLineItem,
	};
	return (
		<ProductContext.Provider value={contextValue}>
			{children}
		</ProductContext.Provider>
	);
};

ProductContextProvider.propTypes = {
	children: PropTypes.node,
	product: PropTypes.object,
	cartLineItem: PropTypes.object,
};
